
<n-modal-background :closeOnEscape="false" :closeOnOutside="false" ref="bg" coverSnackbars @close="$emit('dismiss')">
  <n-modal-body class="getting-started-modal" width="m">
    <div class="main">
      <div class="content">
        <div class="messages">
          <header>{{ $t('framework.welcomeToNotch') }}</header>
          <p class="subtitle">
            {{
              isDesktopViewport
                ? $t('framework.welcomeToNotchDescription')
                : $t('framework.welcomeToNotchDescriptionMobile')
            }}
          </p>
        </div>
        <template v-if="isDesktopViewport">
          <p class="features-title">{{ $t('onboarding.highlightedFeatures') }}</p>
          <ul class="plan-features">
            <li class="check-item" v-for="(feature, index) in highlightedFeatures" :key="index">
              <n-icon class="icon-space" icon="check-circle" size="s" />
              <p class="feature-name">{{ feature.featureName }}</p>
              <p class="feature-description">{{ feature.featureDescription }}</p>
            </li>
          </ul>
        </template>
        <footer>
          <n-button variant="tertiary" :label="$t('onboarding.dismiss')" @click="dismiss" />
          <n-button :label="$t('onboarding.createYourFirstSpace')" icon="arrow-right" @click="openTemplateManager" />
        </footer>
      </div>
      <div class="video" v-if="isDesktopViewport">
        <video
          ref="welcomeVideo"
          :src="welcomeVideoLink"
          :poster="gettingStartedImageLink"
          autoplay
          muted
          loop
          playsinline
        />
      </div>
    </div>
  </n-modal-body>
</n-modal-background>
